<template>
  <div class="ready-mobile">
    <div style="background:rgba(249, 249, 249, 1);">
      <div class="header" id="header">
        <div>
          <p class="title">{{$t('RedteaReady.title1')}}</p>
          <div class="img">
            <img :src="mreadyImg" />
          </div>
          <p class="content">{{$t('RedteaReady.des1')}}</p>
          <p
            style="color: rgba(32, 49, 82, 1);font-family: 'Poppins-ExtraLight';font-size: 0.12rem;text-align: left;margin-top: 0.2rem;"
          >
            {{$t('RedteaReady.des2')}}
            <router-link to="/CaaS" style="color:rgba(211, 36, 23, 1);">
              <span>{{$t('RedteaReady.desLink')}}</span>
            </router-link>
            {{$t('RedteaReady.des222')}}
          </p>
          <a href="https://redteaready.cn/" target="blank">
            <p class="img-more">
              {{$t('LEARN')}}&nbsp;&nbsp;
              <img
                src="../assets/go-mobile/跳转 (5).svg"
                style="width:0.11rem;"
              />
            </p>
          </a>
        </div>
      </div>
    </div>

    <div style="background:rgba(117, 130, 154, 1);">
      <div class="app">
        <p class="title">{{$t('RedteaReady.title2')}}</p>
        <div class="flex-box">
          <div style="margin-bottom:0.2rem;">
            <p class="title-little">{{$t('RedteaReady.app.title1')}}/p></p>
            <p class="content">- {{$t('RedteaReady.app.text1')}}</p>
            <p class="content">- {{$t('RedteaReady.app.text2')}}/p></p>
            <p class="content">- {{$t('RedteaReady.app.text3')}}</p>
          </div>
          <div>
            <p class="title-little">{{$t('RedteaReady.app.title2')}}</p>
            <p class="content">- {{$t('RedteaReady.app.text4')}}</p>
            <p class="content">- {{$t('RedteaReady.app.text5')}}</p>
            <p class="content">- {{$t('RedteaReady.app.text6')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="earth">
      <img :src="mreadyImg1" />
    </div>

    <div class="img-box">
      <img src="../assets/ready-mobile/1 手机.png" />
      <p class="title" id="FWA">{{$t('RedteaReady.fwa.title')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.fwa.des')}}</p>
      <p class="content">{{$t('RedteaReady.fwa.title1')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.fwa.text1')}}</p>
      <p class="content">{{$t('RedteaReady.fwa.title2')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.fwa.text2')}}</p>
      <img src="../assets/ready-mobile/2 手机.png" />
      <p class="title" id="Automotive">{{$t('RedteaReady.auto.title')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.auto.des')}}</p>
      <p class="content">{{$t('RedteaReady.auto.title1')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.auto.text1')}}</p>
      <p class="content">{{$t('RedteaReady.auto.title2')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.auto.text2')}}</p>
      <img src="../assets/ready-mobile/3 手机.png" />
      <p class="title" id="Handheld">{{$t('RedteaReady.hand.title')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.hand.des')}}</p>
      <p class="content">{{$t('RedteaReady.hand.title1')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.hand.text1')}}</p>
      <p class="content">{{$t('RedteaReady.hand.title2')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.hand.text2')}}</p>
      <p class="content">{{$t('RedteaReady.hand.title3')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.hand.text3')}}</p>
      <img src="../assets/ready-mobile/4 手机.png" />
      <p class="title" id="Logistics">{{$t('RedteaReady.log.title')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.log.des')}}</p>
      <img src="../assets/ready-mobile/5手机.png" />
      <p class="title" id="Utilities">{{$t('RedteaReady.uti.title')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.uti.des')}}</p>
      <p class="content">{{$t('RedteaReady.uti.title1')}}</p>
      <p class="content" style="margin-bottom:0.2rem;">{{$t('RedteaReady.uti.text1')}}</p>
      <p class="content">{{$t('RedteaReady.uti.title2')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.uti.text2')}}</p>
      <img src="../assets/ready-mobile/6手机.png" />
      <p class="title" id="Wearable">{{$t('RedteaReady.wear.title')}}</p>
      <p class="content" style="margin-bottom:0.4rem;">{{$t('RedteaReady.wear.des')}}</p>
    </div>

    <div class="brand">
      <p class="title">{{$t('RedteaReady.brands.title')}}</p>
      <img src="../assets/ready-mobile/RedteaMobile_ picture1 web.png" />
      <p class="little-title">{{$t('RedteaReady.brands.title1')}}</p>
      <p class="content">{{$t('RedteaReady.brands.text1')}}</p>
      <img src="../assets/ready-mobile/RedteaMobile_ picture2 web.png" style="margin-top:0.2rem;" />
      <p class="little-title">{{$t('RedteaReady.brands.title2')}}</p>
      <p
        style="margin: 0.2rem 0;color: rgba(32, 49, 82, 1);font-family: 'Poppins-ExtraLight';font-size: 0.12rem;text-align: left;"
      >{{$t('RedteaReady.brands.text2')}}</p>
      <img src="../assets/ready-mobile/RedteaMobile_ picture3 web.png" />
      <p class="little-title">{{$t('RedteaReady.brands.title3')}}</p>
      <p class="content">{{$t('RedteaReady.brands.text3')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedteaReady-mobile',
  components: {},
  computed: {
    mreadyImg() {
      return this.$store.state.mreadyImg
    },
    mreadyImg1() {
      return this.$store.state.mreadyImg1
    }
  }
}
</script>
<style lang="less" scoped>
.ready-mobile {
  padding-top: 0.84rem;
  .header {
    padding: 0.2rem;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
      padding: 0 0.2rem;
      margin-bottom: 0.2rem;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-ExtraLight';
      font-size: 0.12rem;
      text-align: left;
      margin-top: 0.2rem;
    }
  }
  .app {
    padding: 0.3rem 0.2rem;
    .title {
      color: rgba(255, 255, 255, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
      text-align: left;
      margin-bottom: 0.2rem;
    }
    .title-little {
      color: rgba(255, 255, 255, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.12rem;
      text-align: left;
      margin-bottom: 0.1rem;
    }
    .content {
      color: rgba(255, 255, 255, 0.8);
      font-family: 'Poppins-ExtraLight';
      font-size: 0.12rem;
      text-align: left;
    }
  }
  .img-box {
    padding: 0.4rem 0.2rem 0.2rem 0.2rem;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.14rem;
      text-align: left;
      margin: 0.2rem 0;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Light';
      font-size: 0.12rem;
      text-align: left;
    }
  }
  .brand {
    padding: 0 0.2rem 0.5rem 0.2rem;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.16rem;
      margin-bottom: 0.2rem;
      text-align: left;
    }
    .little-title {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-Regular';
      font-size: 0.14rem;
      text-align: left;
      margin: 0.3rem 0 0.1rem 0;
    }
    .content {
      color: rgba(32, 49, 82, 1);
      font-family: 'Poppins-ExtraLight';
      font-size: 0.12rem;
      text-align: left;
    }
  }
  .img-more {
    color: rgba(207, 42, 42, 1);
    font-family: 'Poppins-Bold';
    font-size: 0.12rem;
    margin: 0.2rem 0 0.4rem 0;
  }
}
</style>
